/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
document.addEventListener('DOMContentLoaded', () => {
	const galleryElement = document.querySelector('[data-fancybox-custom="gallery"]');
	const closeText = galleryElement?.dataset.fancyboxCloseText;

	Fancybox.bind('[data-fancybox-custom="gallery"]', {
		groupAll: true,
		closeButton: true,
		on: {
			done: (fancybox, slide) => {
				const closeButton = slide.el.querySelector('.is-close-btn');
				if (closeButton) {
					closeButton.classList.add(...['btn', 'outline']);
					closeButton.innerHTML = closeText + closeButton.innerHTML;

					// Download current image button
					const downloadButton = document.createElement('button');
					downloadButton.classList.add(...['btn', 'outline', 'download-image-btn', 'has-icon-right']);
					downloadButton.innerHTML = 'Download<i class="fa-solid fa-download"></i>';
					downloadButton.classList.add(...['is-close-btn', 'is-download-btn', 'f-button']);
					downloadButton.style.marginRight = closeButton.getBoundingClientRect().width + 16 + 'px';

					downloadButton.addEventListener('click', () => {
						downloadCurrentSlideImage(slide);
					});
					closeButton.parentNode.insertBefore(downloadButton, closeButton);
				}
				resizeFancyboxCaption(slide);
			},
			'Carousel.ready Carousel.change': (fancybox) => {
				const slide = fancybox.getSlide();
				resizeFancyboxCaption(slide);

				// Update download button for new slide
				const downloadButton = slide.el.querySelector('.download-image-btn');
				if (downloadButton) {
					downloadButton.onclick = () => downloadCurrentSlideImage(slide);
				}
			},
		},
	});
});

// Download current slide image
function downloadCurrentSlideImage(slide) {
	const img = slide.contentEl?.querySelector('img');
	if (!img || !img.src) {
		return;
	}

	// Create a temporary link element
	const link = document.createElement('a');
	link.href = img.src;
	link.download = img.alt || 'gallery-image';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

// re-align the caption to the width of the image
function resizeFancyboxCaption(slide) {
	const captionEl = slide.captionEl;
	const wrapperEl = slide.contentEl || slide.$content?.[0];
	if (!captionEl || !wrapperEl) {
		return;
	}

	// Wrap caption content in a span if not already wrapped
	if (!captionEl.querySelector('span')) {
		const captionContent = captionEl.innerHTML;
		captionEl.innerHTML = `<span>${captionContent}</span>`;
	}

	captionEl.style.visibility = 'hidden';
	captionEl.style.width = '';

	void captionEl.offsetWidth;

	for (let i = 0; i < 3; i++) {
		captionEl.style.width = `${Math.max(200, wrapperEl.getBoundingClientRect().width)}px`;
	}

	captionEl.style.visibility = '';
}
